import { type AvatarSize } from '#components/avatar/config';

/**
 * Get initials from a given name, based on the size of the avatar
 *
 * Examples, for "Philippe Etchebest":
 * - Smaller sizes: P
 * - Bigger sizes: PE
 */
export function getInitials(name: string, size: AvatarSize = 'small'): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map(initial => (initial[0] ? initial[0].toUpperCase() : ''))
    .slice(0, ['xx-small', 'x-small'].includes(size) ? 1 : 2)
    .join('');
}
